import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Blocks, Blinds, Crown, Search, CirclePlus } from "lucide-react";


export default function Dashboard() {
  const navigate = useNavigate();

  const evento_id = Number(localStorage.getItem("evento") || 0);

  useEffect(() => {
    if (evento_id === 0) {
      navigate("/addeventos");
    }
  }, [evento_id, navigate]);

  return (
    <div className="page-container">
      <div className="dashboard-container">
        <div className="user-grid">
          <div className="user-card">
            <h3><CirclePlus size={20} /> Cadastro</h3>
            <div className="card-actions">
              <button
                className="btn-primary icone-btn"
                onClick={() => navigate("/addclients")}
              >
                <Crown size={20} /> Cliente
              </button>
              <button
                className="btn-primary icone-btn"
                onClick={() => navigate("/addcotacao")}
              >
                <Blocks size={20} /> Cotação
              </button>
            </div>
          </div>
          <div className="user-card">
            <h3><Search size={20} /> Consulta</h3>
            <div className="card-actions">
              <button
                className="btn-primary icone-btn"
                onClick={() => navigate("/listproducts")}
              >
                <Blinds size={20} /> Produtos
                </button>
              <button
                className="btn-primary"
                onClick={() => navigate("/listclients")}
              >
                <Crown size={20} /> Clientes
              </button>
              <button
                className="btn-primary icone-btn"
                onClick={() => navigate("/listcotacoes")}
              >
                <Blocks size={20} /> Cotações
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
